<template>
<div class="container-fluid text-center">
  <div class="row">
    <div class="col-auto mx-auto">
      <div class="mt-2 d-inline-flex" v-html="message">
       
      </div>
    </div>
  </div>
</div>
</template>

<script setup>
defineProps({
  message: String
});
</script>
